/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GeneratePreviewReportPreviewMutationRequest, GeneratePreviewReportPreviewMutationResponse, GeneratePreviewReportPreviewPathParams, GeneratePreviewReportPreviewQueryParams, GeneratePreviewReportPreview400, GeneratePreviewReportPreview404 } from "../models/GeneratePreviewReportPreview";

export function getGeneratePreviewReportPreviewUrl(reportType: GeneratePreviewReportPreviewPathParams["reportType"]) {
  const res = { method: 'POST', url: `/report-previews/${reportType}` as const }
  return res
}

/**
 * @description Generates a full report preview in the specified format using sample data from the blueprint. The preview executes the complete report generation pipeline to demonstrate realistic report output. Sample data is kept server-side and never exposed to clients. Requires a preview definition in the request body.
 * @summary Generate report preview
 * {@link /report-previews/:reportType}
 */
export async function generatePreviewReportPreview(reportType: GeneratePreviewReportPreviewPathParams["reportType"], data: GeneratePreviewReportPreviewMutationRequest, params: GeneratePreviewReportPreviewQueryParams, config: Partial<RequestConfig<GeneratePreviewReportPreviewMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<GeneratePreviewReportPreviewMutationResponse, ResponseErrorConfig<GeneratePreviewReportPreview400 | GeneratePreviewReportPreview404>, GeneratePreviewReportPreviewMutationRequest>({ method : "POST", url : getGeneratePreviewReportPreviewUrl(reportType).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}